/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const TOGGLE_SIDEBAR = '@GLOBAL/TOGGLE_SIDEBAR'
export const HOVER_SIDEBAR = '@GLOBAL/HOVER_SIDEBAR'

// modal error
export const SHOW_MODAL_MESSAGE = '@GLOBAL/SHOW_MODAL_MESSAGE'
export const HIDE_MODAL_MESSAGE = '@GLOBAL/HIDE_MODAL_MESSAGE'

// overlay
export const SHOW_OVERLAY = '@GLOBAL/SHOW_OVERLAY'
export const HIDE_OVERLAY = '@GLOBAL/HIDE_OVERLAY'
